export class SensitivityLabelsFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<SensitivityLabelsFiltersInEnum>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<SensitivityLabelsFiltersNotInEnum>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SensitivityLabelsFilters.attributeTypeMap;
    }
    constructor() {
    }
}
export var SensitivityLabelsFiltersInEnum;
(function (SensitivityLabelsFiltersInEnum) {
    SensitivityLabelsFiltersInEnum["True"] = "true";
    SensitivityLabelsFiltersInEnum["False"] = "false";
})(SensitivityLabelsFiltersInEnum || (SensitivityLabelsFiltersInEnum = {}));
export var SensitivityLabelsFiltersNotInEnum;
(function (SensitivityLabelsFiltersNotInEnum) {
    SensitivityLabelsFiltersNotInEnum["True"] = "true";
    SensitivityLabelsFiltersNotInEnum["False"] = "false";
})(SensitivityLabelsFiltersNotInEnum || (SensitivityLabelsFiltersNotInEnum = {}));
